module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-collector-2.282e0228.svg";